// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"720a9f37","239":"94047458","455":"ded26b86","488":"5c0bd366"}[chunkId] + ".chunk.js";
};